import NavigationBar from './components/NavigationBar';

export default NavigationBar;
